import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BureauCnpjInformationModel } from 'src/app/order/components/proposal-data/qsa-data/models/bureau-cnpj-information.model';
import { ValidatePartnerRequest } from 'src/app/order/components/proposal-data/qsa-data/models/validate-partner.model';
import { DataStoreService } from 'src/app/order/store/data-store.service';
import { UserDataModel } from 'src/app/shared/models/user-data.model';
import { environment } from 'src/environments/environment.local';

@Injectable({
  providedIn: 'root',
})
export class BureauService {
  public userData: UserDataModel;

  constructor(private http: HttpClient, private dataStoreService: DataStoreService) {
    this.userData = this.dataStoreService.getUserData();
  }

  public getCnpjInformation(cnpj: string): Observable<BureauCnpjInformationModel> {
    return this.http.get<BureauCnpjInformationModel>(`${environment.apiUrls.bureauCnpjInformation}/${cnpj}`, {
      headers: this.buildHeaders(),
    });
  }

  // A API responde com um boolean puro: true = quadro societario valido, false = reprovado.
  public validatePartner(request: ValidatePartnerRequest): Observable<boolean> {
    const headers = this.buildHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json');

    return this.http.post<boolean>(`${environment.apiUrls.bureauValidatePartner}`, request, { headers });
  }

  private buildHeaders(): HttpHeaders {
    return new HttpHeaders()
      .set('Institution', this.userData.institution)
      .set('ServiceContract', this.userData.serviceContract.toString())
      .set('Requestor', 'FISERV_ONLINE');
  }
}
